import { render, staticRenderFns } from "./supplierList.vue?vue&type=template&id=00cbb928&scoped=true"
import script from "./supplierList.vue?vue&type=script&lang=js"
export * from "./supplierList.vue?vue&type=script&lang=js"
import style0 from "./supplierList.vue?vue&type=style&index=0&id=00cbb928&prod&scoped=true&lang=css"
import style1 from "./supplierList.vue?vue&type=style&index=1&id=00cbb928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cbb928",
  null
  
)

export default component.exports